import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

import a1 from "../Assets/a1.png";
import a2 from "../Assets/a2.png";
import a3 from "../Assets/a3.png";
import a4 from "../Assets/a4.png";
import a5 from "../Assets/a5.png";
import a7 from "../Assets/a7.png";

const GallerySection: React.FC = () => {
  const images = [a1, a2, a3, a4, a5, a7];

  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  return (
    <>
      <section className="bg-gradient-to-b from-white via-yellow-50 to-blue-50 py-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          {/* Heading */}
          <div className="inline-flex items-center justify-center gap-3 bg-yellow-100 border-l-4 border-yellow-400 px-4 py-2 rounded shadow-sm mb-6">
            <h2 className="text-3xl font-bold text-blue-900">
              Academy Gallery
            </h2>
          </div>

          <p className="text-gray-700 max-w-3xl mx-auto mb-10 text-lg">
            Glimpse of Haifa Academy — classrooms, training grounds, activities
            & campus environment.
          </p>

          {/* Image Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {images.map((img, i) => (
              <motion.div
                key={i}
                className="overflow-hidden rounded-xl shadow-md bg-white cursor-pointer"
                whileHover={{ scale: 1.02 }}
                transition={{ duration: 0.4 }}
                onClick={() => setSelectedImage(img)}
              >
                <img
                  src={img}
                  alt={`Gallery-${i}`}
                  className="w-full h-56 object-cover hover:scale-110 transition-transform duration-500"
                />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Dialog / Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[999]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)} // click outside to close
          >
            {/* Image Container */}
            <motion.div
              className="relative bg-white p-3 rounded-xl shadow-xl max-w-3xl w-[90%]"
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.7, opacity: 0 }}
              onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
            >
              {/* Close Button */}
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute top-3 right-3 bg-white p-2 rounded-full shadow hover:bg-gray-100"
              >
                <X className="h-5 w-5 text-gray-700" />
              </button>

              <img
                src={selectedImage}
                alt="Preview"
                className="w-full max-h-[75vh] object-contain rounded-lg"
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default GallerySection;
